// React bootstrap table next =>
// DOCS: https://react-bootstrap-table.github.io/react-bootstrap-table2/docs/
// STORYBOOK: https://react-bootstrap-table.github.io/react-bootstrap-table2/storybook/index.html
import React, { useMemo } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider
} from "react-bootstrap-table2-paginator";
import { shallowEqual, useSelector } from "react-redux";
import {
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage
} from "../../../../../_metronic/_helpers";
import { Pagination } from "../../../../../_metronic/_partials/controls";
import { useTransactionsReportUIContext } from "../TransactionsReportUIContext";
import * as uiHelpers from "../TransactionsReportUIHelpers";
import * as columnFormatters from "./column-formatters";
import columns from "./ColumnWrapper";

export function TransactionsReportTable({}) {
  // History UI Context
  const transactionsReportUIContext = useTransactionsReportUIContext();
  const transactionsReportUIProps = useMemo(() => {
    return {
      ids: transactionsReportUIContext.ids,
      setIds: transactionsReportUIContext.setIds,
      queryParams: transactionsReportUIContext.queryParams,
      setQueryParams: transactionsReportUIContext.setQueryParams,
      openReceiptDialog: transactionsReportUIContext.openReceiptDialog
    };
  }, [transactionsReportUIContext]);

  const { currentState } = useSelector(
    (state) => ({ currentState: state.transactionsReport }),
    shallowEqual
  );
  const { totalCount, entities, listLoading } = currentState || {};

  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: transactionsReportUIProps.queryParams.pageSize,
    onPageChange: (page) => {
      if (page === 0) return;
    }
  };

  // Table columns
  const cols = columns({ columnFormatters, transactionsReportUIProps });

  return (
    <>
      <PaginationProvider pagination={paginationFactory(paginationOptions)}>
        {({ paginationProps, paginationTableProps }) => {
          return (
            <Pagination
              isLoading={listLoading}
              paginationProps={paginationProps}
            >
              <BootstrapTable
                wrapperClasses="table-responsive"
                classes="table table-head-custom table-head-bg table-borderless table-vertical-center history-table"
                bootstrap4
                bordered={false}
                remote
                keyField="transactionId"
                data={entities ? entities : []}
                columns={cols}
                // defaultSorted={uiHelpers.defaultSorted}
                onTableChange={getHandlerTableChange(
                  transactionsReportUIProps.setQueryParams
                )}
                {...paginationTableProps}
              >
                <PleaseWaitMessage isLoading={listLoading} />
              </BootstrapTable>
              <NoRecordsFoundMessage
                entities={entities}
                errorMessage={"No transactions found!"}
              />
            </Pagination>
          );
        }}
      </PaginationProvider>
    </>
  );
}
